import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import PresentationTable from '../../../../organisms/PresentationTable'
import { useFormattingContext } from '../../../../organisms/FormattingProvider/FormattingContext'
import { useEffectiveTargetModel } from '../../../../../api/rebalancer'
import FadeIn from '../../../../molecules/Transitions/FadeIn'
import { useColumns } from './columnConfig'

const useStyles = makeStyles((theme) => ({
  analysisTable: {
    minHeight: '300px'
  }
}))

function EffectiveModelTable ({ targetModelId }) {
  const { formatter } = useFormattingContext()
  const { columns, defaultSort } = useColumns({ formatter })
  const { data, isLoading } = useEffectiveTargetModel(targetModelId)
  const classes = useStyles()

  return (
    <FadeIn className={classes.analysisTable} delay={0.3}>
      <PresentationTable
        columns={columns}
        data={data || []}
        loading={isLoading}
        defaultSort={defaultSort}
        sortable
        variant='bordered'
      />
    </FadeIn>
  )
}

EffectiveModelTable.propTypes = {
  targetModelId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
}

export default EffectiveModelTable
